import { EntityApi } from "../../services/ApiPlatform";

export abstract class InternshipStudentApi extends EntityApi {
    protected static GET_COLLECTION = "/api/internship-students";

    protected static POST_COLLECTION = "/api/internship-students";

    protected static GET_ITEM = "/api/internship-students/{id}";

    protected static PUT_ITEM = "/api/internship-students/{id}";

    protected static PATCH_ITEM = "/api/internship-students/{id}";

    protected static DELETE_ITEM = "/api/internship-students/{id}";
}
